<template>
  <Modal @close="close" :active="active">
    <div class="modal-confirm">
      <div class="confirm-title">Verifique seu e-mail e confirme a mudança da sua senha!</div>
      <Button @click="close" type="primary" title="Ok!" />
    </div>
  </Modal>
</template>

<script>
import Modal from '../Modal'
import Button from '../Button'

export default {
  name: 'ModalConfirm',
  components: {
    Modal,
    Button
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close (event = false) {
      this.$emit('close', event)
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
